module.exports = __webpack_public_path__ + "img/1.87084503.jpg";